const defaultState = {
	id:"",
    name:"",
    description: ""
};
export const retailer = (state = defaultState, action) => {
    switch (action.type) {
        default:
            return state;
    }
}